import React from 'react';
import { useTranslation } from 'react-i18next';
import { BookOpenIcon, GraduationCapIcon, CodeIcon, CalendarIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function Courses() {
  const {
    t
  } = useTranslation();
  const courseCategories = [{
    icon: BookOpenIcon,
    category: t('courses.categories.english'),
    courses: ['Basic English Language', 'Intermediate English Language', 'Advanced English Language', 'Diploma in English', 'Public Speaking'],
    gradientClass: 'bg-gradient-to-br from-teal-400 to-teal-600',
    textColor: 'text-teal-600'
  }, {
    icon: GraduationCapIcon,
    category: t('courses.categories.ielts'),
    courses: ['IELTS Preparations'],
    gradientClass: 'bg-gradient-to-br from-blue-400 to-blue-600',
    textColor: 'text-blue-600'
  }, {
    icon: BookOpenIcon,
    category: t('courses.categories.french'),
    courses: ['French Classes'],
    gradientClass: 'bg-gradient-to-br from-indigo-400 to-indigo-600',
    textColor: 'text-indigo-600'
  }, {
    icon: BookOpenIcon,
    category: t('courses.categories.arabic'),
    courses: ['Arabic Language'],
    gradientClass: 'bg-gradient-to-br from-purple-400 to-purple-600',
    textColor: 'text-purple-600'
  }, {
    icon: GraduationCapIcon,
    category: t('courses.categories.school'),
    courses: ['Class 1 to 12 (All Subjects)', 'All Boards'],
    gradientClass: 'bg-gradient-to-br from-pink-400 to-pink-600',
    textColor: 'text-pink-600'
  }, {
    icon: GraduationCapIcon,
    category: t('courses.categories.university'),
    courses: ['BCA, BBA, BCOM, BSC', 'MCA, MBA'],
    gradientClass: 'bg-gradient-to-br from-rose-400 to-rose-600',
    textColor: 'text-rose-600'
  }, {
    icon: CodeIcon,
    category: t('courses.categories.computer'),
    courses: ['AI & ML', 'Networking', 'Cyber Security', 'Editing and Videography', 'Tally', 'SAP', 'Basic Computer', 'MS Office (Excel, Word, PowerPoint)'],
    gradientClass: 'bg-gradient-to-br from-cyan-400 to-cyan-600',
    textColor: 'text-cyan-600'
  }, {
    icon: CodeIcon,
    category: t('courses.categories.programming'),
    courses: ['Python', 'Java', 'HTML', 'C Language', 'C++', 'SQL'],
    gradientClass: 'bg-gradient-to-br from-emerald-400 to-emerald-600',
    textColor: 'text-emerald-600'
  }];
  return <section className="w-full py-32 px-6 bg-gradient-to-b from-white to-slate-50" data-id="element-65">
      <div className="max-w-7xl mx-auto" data-id="element-66">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-67">
          <h2 className="text-5xl md:text-6xl font-bold mb-6" data-id="element-68">
            <span className="text-gradient" data-id="element-69">{t('courses.title')}</span>
          </h2>
          <p className="text-xl md:text-2xl text-slate-600 font-light mb-10" data-id="element-70">
            {t('courses.subtitle')}
          </p>
          <motion.a href="https://cal.com" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-flex items-center gap-3 glass px-10 py-5 rounded-full text-lg font-semibold shadow-xl hover:shadow-2xl transition-all" data-id="element-71">
            <CalendarIcon className="w-6 h-6 text-teal-600" data-id="element-72" />
            <span className="text-gradient" data-id="element-73">{t('courses.bookMeeting')}</span>
          </motion.a>
        </motion.div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-74">
          {courseCategories.map((category, index) => {
          const Icon = category.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.05
          }} whileHover={{
            y: -8,
            scale: 1.02
          }} data-id="element-75">
                <div className="glass rounded-3xl p-7 shadow-xl hover:shadow-2xl transition-all h-full" data-id="element-76">
                  <div className="flex items-center gap-4 mb-5" data-id="element-77">
                    <div className={`w-12 h-12 ${category.gradientClass} rounded-xl flex items-center justify-center shadow-lg`} data-id="element-78">
                      <Icon className="w-6 h-6 text-white" data-id="element-79" />
                    </div>
                    <h3 className="text-xl font-bold text-slate-800" data-id="element-80">
                      {category.category}
                    </h3>
                  </div>
                  <ul className="space-y-3" data-id="element-81">
                    {category.courses.map((course, courseIndex) => <li key={courseIndex} className="text-slate-700 flex items-start gap-3 text-base" data-id="element-82">
                        <span className={`${category.textColor} mt-1 text-lg`} data-id="element-83">
                          •
                        </span>
                        <span data-id="element-84">{course}</span>
                      </li>)}
                  </ul>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}